module.exports = __webpack_public_path__ + "static/media/icon.45d36ab7.png";